<div class="g-layout__container">
    
    <!-- Page Header -->
    <div class="page-header">
        <div class="header-content">
            <h2 class="page-title">
                <i class="fa-solid fa-clipboard-check"></i>
                {{ 'ReviewMilestoneOutputs' | navTitle | async }}
            </h2>
        </div>
    </div>

    <!-- Filters Section -->
    <div class="filters-container">
        <div class="filter-row">
            <!-- Strategy Dropdown -->
            <div class="filter-section">
                <div class="filter-label">
                    <i class="fa-solid fa-chess"></i>
                    <span>{{'strategy'|translate}}</span>
                </div>
                <div class="strategy-dropdown-wrapper">
                    <p-dropdown 
                        (onChange)="strategyOptionsChange()" 
                        [(ngModel)]="selectedStrategyId"
                        [options]="strategyOptions" 
                        optionLabel="name" 
                        optionValue="strategyId" 
                        placeholder="{{'choose_strategy'|translate}}"
                        styleClass="modern-dropdown" />
                </div>
            </div>

            <!-- Search Section -->
            <div class="filter-section">
                <div class="filter-label">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    <span>{{'search'|translate}}</span>
                </div>
                <div class="search-input-wrapper">
                    <i class="fa-solid fa-search search-icon"></i>
                    <input 
                        type="text" 
                        class="modern-search-input"
                        placeholder="{{'search_by_name'|translate}}" 
                        [(ngModel)]="searchText"
                        (ngModelChange)="filterProjects()" />
                </div>
            </div>
        </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
        <p-table #table [paginator]="true" [rows]="10" [rowsPerPageOptions]="[5, 10, 20]" [class]="dir"
            [value]="filteredProjects" dataKey="id" [tableStyle]="{ 'width': '100%' }"
            (onRowExpand)="onRowExpand($event)" (onRowCollapse)="onRowCollapse($event)"
            styleClass="modern-projects-table">

        <ng-template pTemplate="header">
            <tr>
                <th style="width: 5rem">
                    <i class="fa-solid fa-chevron-down"></i>
                </th>
                <th [class]="dir=='rtl'?'text-right':'text-left'">
                    <i class="fa-solid fa-diagram-project"></i>
                    {{'name'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-chart-line"></i>
                    {{'progress_percentage'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-arrow-up-right-from-square"></i>
                    {{'actions'|translate}}
                </th>
            </tr>
        </ng-template>



        <ng-template pTemplate="body" let-project let-expanded="expanded">
            <tr class="cursor-pointer" (click)="expanded ? table.toggleRow(project) : table.toggleRow(project)">
                <td>

                    <p-button (click)="expanded ? table.toggleRow(project) : table.toggleRow(project)" type="button"
                        pRipple [pRowToggler]="project" [text]="true" [rounded]="true" [plain]="true"
                        [icon]="expanded ? 'pi pi-chevron-up':'pi pi-chevron-down'" />
                </td>
                <td [class]="dir=='rtl'?'text-right':'text-left'" class="font-bold">
                    {{ project.name }}
                </td>
                <td [class]="dir=='rtl'?'text-right':'text-left'">
                    <div [ngStyle]="{'backGround-color':project.progress_color?project.progress_color:''}"
                        class="h-2rem shadow-3 p-2  g-c-white font-bold  border-round-lg  m-1 flex justify-content-center align-items-center w-3rem">
                        {{project.progress_percentage}}%
                    </div>
                </td>
                <td>
                    <a [routerLink]="['/strategies',selectedStrategyId,'projects',project.id]">

                        <p-button pTooltip="{{'go_to_project' | translate}}" routerLinkActive="router-link-active">
                            @if(dir=='rtl'){
                            <i class="fa-solid fa-arrow-up-right-from-square fa-flip-horizontal"></i>
                            }@else{
                            <i class="fa-solid fa-arrow-up-right-from-square"></i>
                            }
                        </p-button>
                    </a>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-project>
            <tr>
                <td colspan="7">
                    <div class="p-3">
                        <p-table [value]="project.files" dataKey="id" styleClass="nested-files-table">
                            <ng-template pTemplate="header">
            <tr>
                <th>
                    <i class="fa-solid fa-file"></i>
                    {{'name'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-note-sticky"></i>
                    {{'notes'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-flag-checkered"></i>
                    {{'milestone_name'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-check-circle"></i>
                    {{'output_status'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-eye"></i>
                    {{'view'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-download"></i>
                    {{'download'|translate}}
                </th>
                <th class="text-center">
                    <i class="fa-solid fa-list-check"></i>
                    {{'assess'|translate}}
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file>
            <tr>
                <td class="font-semibold">
                    <i class="{{getFileIcon(file.file_type)}}"></i>
                    {{ file.file_name }}


                </td>
                <td class="font-semibold text-center">
                    {{ file.comments }}
                </td>
                <td class="text-center">
                    {{ file.subEntityName }}



                </td>
                <!-- <td class="text-center">{{ file.file_type }}</td> -->
                <td class="text-center">
                    <div class="mr-3">


                        @if(dir=='rtl'){
                        @if(file.status=='approved'){
                        <p-tag severity="success" value="معتمد" />
                        }

                        @if(file.status=='rejected'){
                        <p-tag severity="danger" value="مرفوض" />
                        }

                        @if(file.status=='pending'){
                        <p-tag severity="warning" value="قيد المراجعة" />
                        }

                        }@else{

                        @if(file.status=='approved'){
                        <p-tag severity="success" value="{{file.status}}" />
                        }

                        @if(file.status=='rejected'){
                        <p-tag severity="danger" value="{{file.status}}" />
                        }

                        @if(file.status=='pending'){
                        <p-tag severity="warning" value="{{file.status}}" />
                        }
                        }

                    </div>




                </td>
                <td class="text-center">
                    <div class="table-action-icon cursor-pointer" (click)="openFileViewer(file)"
                        pTooltip="{{'view'|translate}}" tooltipPosition="top">
                        <i class="fa-solid fa-eye"></i>
                    </div>
                </td>
                <td class="text-center">
                    <div class="table-action-icon cursor-pointer" (click)="downloadFile(file)"
                        pTooltip="{{'download'|translate}}" tooltipPosition="top">
                        <i class="fa-solid fa-download"></i>
                    </div>
                </td>
                <td class="text-center">
                    <a [routerLink]="['/project-file-auditor']" [queryParams]="{
                        strategyId: selectedStrategyId,
                        parentEntityId: project.id,
                        subEntityId: file.parent_entity_id
                    }">
                        <div class="table-action-icon cursor-pointer"
                            pTooltip="{{'output_assessment'|translate}}" tooltipPosition="top">
                            <i class="fa-solid fa-list-check"></i>
                        </div>
                    </a>
                </td>

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-c>
            <tr>
                <td class="text-center font-bold text-lg" [attr.colspan]="9">
                    <i class="fa-solid fa-circle-exclamation"></i>
                    {{'no_data_found' | translate}}
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
</td>
</tr>
</ng-template>
</p-table>
</div>


@if(isFileViewer){
<p-dialog header="{{selectedFile?.file_name}}" [modal]="true" [(visible)]="isFileViewer" [style]="{ width: '90rem' }"
    [breakpoints]="{ '1199px': '90vw', '575px': '90vw' }" [maximizable]="true">
    <div>
        <web-viewer [fileUrl]="selectedFile"></web-viewer>
    </div>
</p-dialog>

}